// extracted by mini-css-extract-plugin
export var btn = "x_b";
export var cardLink = "x_D";
export var cardTitle = "x_G";
export var cardWrap = "x_C";
export var smooth = "x_d";
export var submit = "x_c";